export default {"src":"/login-app/[GIT_HASH]/_next/static/media/more_vert.78a2db50.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};